module.exports = __webpack_public_path__ + "static/img/google-sheets.393ac4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/integrations/google-sheets.png
// module id = 624
// module chunks = 2